import React, { useState, Component } from 'react';
import { SearchIcon, FilterIcon, ChevronRightIcon, ChevronLeftIcon, CheckCircleIcon, ClockIcon, TruckIcon, PackageIcon, ShieldIcon, ArrowRightIcon, CalendarIcon, InfoIcon, MapPinIcon, DownloadIcon, SlidersIcon, XCircleIcon, AlertCircleIcon, ChevronDownIcon, ArrowUpDownIcon, PlusIcon, MoreHorizontalIcon, EyeIcon, FileTextIcon, RefreshCwIcon, BoxIcon, TagIcon, DollarSignIcon, BuildingIcon, UserIcon, ChevronUpIcon, ListFilterIcon, SlidersHorizontalIcon, ArrowDownIcon, ArrowUpIcon, BarChartIcon, PieChartIcon, GridIcon, ListIcon, BellIcon, HelpCircleIcon, BarChart3Icon } from 'lucide-react';
// Component for tab buttons
function TabButton({
  active,
  onClick,
  label
}) {
  return <button className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${active ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white' : 'text-blue-200 hover:bg-white/5'}`} onClick={onClick} data-id="element-11316" data-mp="2dxednqmweab8">
      {label}
    </button>;
}
// Component for shipping status boxes
function ShippingStatusBox({
  status,
  label,
  date
}) {
  const getIcon = status => {
    switch (status) {
      case 'completed':
        return <CheckCircleIcon size={16} className="text-emerald-500" data-id="element-11317" data-mp="32fflqvsyexbw" />;
      case 'pending':
        return <ClockIcon size={16} className="text-gray-400" data-id="element-11318" data-mp="2ofoav3xqhx24" />;
      default:
        return <AlertCircleIcon size={16} className="text-amber-500" data-id="element-11319" data-mp="2te7zjc3ppmy6" />;
    }
  };
  return <div className="flex flex-col items-center bg-white/5 rounded-lg p-1.5" data-id="element-11320" data-mp="2epv0u7d8ppzz">
      {getIcon(status)}
      <span className="text-xs text-blue-300 mt-1 text-center" data-id="element-11321" data-mp="2jhmuwrvluduv">{label}</span>
      {date && <span className="text-xs text-blue-200 mt-0.5 text-center" data-id="element-11322" data-mp="25pyi0mdj7lcu">{date}</span>}
    </div>;
}
// Component for order cards in grid view
function OrderCard({
  order
}) {
  const getStatusColor = status => {
    switch (status) {
      case 'shipped':
        return 'text-emerald-500';
      case 'scheduled':
        return 'text-blue-500';
      case 'pending':
        return 'text-amber-500';
      case 'canceled':
        return 'text-red-500';
      default:
        return 'text-gray-500';
    }
  };
  const getStatusBg = status => {
    switch (status) {
      case 'shipped':
        return 'bg-emerald-500/20';
      case 'scheduled':
        return 'bg-blue-500/20';
      case 'pending':
        return 'bg-amber-500/20';
      case 'canceled':
        return 'bg-red-500/20';
      default:
        return 'bg-gray-500/20';
    }
  };
  const getStatusIcon = status => {
    switch (status) {
      case 'shipped':
        return <TruckIcon size={14} data-id="element-11323" data-mp="l8z3evtb373b" />;
      case 'scheduled':
        return <CalendarIcon size={14} data-id="element-11324" data-mp="g8b3fkn3nfwy" />;
      case 'pending':
        return <ClockIcon size={14} data-id="element-11325" data-mp="g6qafzgfo517" />;
      case 'canceled':
        return <XCircleIcon size={14} data-id="element-11326" data-mp="b8exvgyr7gfa" />;
      default:
        return <InfoIcon size={14} data-id="element-11327" data-mp="bbuh8vzgnbmi" />;
    }
  };
  return <div className="bg-gradient-to-br from-white/5 to-white/10 rounded-lg overflow-hidden border border-white/10 hover:border-white/20 transition-colors" data-id="element-11328" data-mp="30ztmz7euvbv0">
      <div className="p-4 border-b border-white/10" data-id="element-11329" data-mp="2lvsa495rnwh4">
        <div className="flex justify-between items-start mb-3" data-id="element-11330" data-mp="2lx3bk2bqos52">
          <div className="font-medium text-white" data-id="element-11331" data-mp="2qubx8cw3jeb2">{order.id}</div>
          <div className={`px-2.5 py-1 rounded-full text-xs font-medium capitalize flex items-center ${getStatusBg(order.status)} ${getStatusColor(order.status)}`} data-id="element-11332" data-mp="2qsqzkeehjf8z">
            {getStatusIcon(order.status)}
            <span className="ml-1" data-id="element-11333" data-mp="30mhqrr1zy3sd">{order.status}</span>
          </div>
        </div>
        <div className="text-sm text-blue-300 flex items-center mb-3" data-id="element-11334" data-mp="34ocoklkpxz1e">
          <CalendarIcon size={14} className="mr-1.5 text-blue-400" data-id="element-11335" data-mp="39k1potcdznzt" />
          {order.date}
        </div>
        <div className="flex justify-between items-end" data-id="element-11336" data-mp="3ekz7v5xeci1b">
          <div data-id="element-11337" data-mp="3jk2e2tp44uav">
            <div className="text-xs text-blue-300 mb-1" data-id="element-11338" data-mp="3jjsjest4hyyu">Products</div>
            <div className="text-sm text-white" data-id="element-11339" data-mp="1k6eu7d7htmrf">{order.products}</div>
          </div>
          <div className="text-right" data-id="element-11340" data-mp="1k8rjkbfkyzei">
            <div className="text-xs text-blue-300 mb-1" data-id="element-11341" data-mp="1p4q2vkm1xr82">Amount</div>
            <div className="text-sm font-medium text-white" data-id="element-11342" data-mp="3fmlgajkrgpa8">{order.amount}</div>
          </div>
        </div>
      </div>
      <div className="p-4 bg-blue-950/30" data-id="element-11343" data-mp="3ao1woptn3pl1">
        <div className="mb-3" data-id="element-11344" data-mp="3an8wk7p6rybv">
          <div className="text-xs text-blue-300 mb-1" data-id="element-11345" data-mp="3onb9rgmju3ks">Bill by</div>
          <div className="text-sm text-white" data-id="element-11346" data-mp="3omid58hb0ugd">{order.billBy}</div>
        </div>
        <div className="mb-4" data-id="element-11347" data-mp="3jpi5wu8pxlno">
          <div className="text-xs text-blue-300 mb-1" data-id="element-11348" data-mp="3jm417fcl10d2">Bill to</div>
          <div className="text-sm text-white truncate" data-id="element-11349" data-mp="2vzfg6ksa0rs8">{order.billTo}</div>
        </div>
        <div className="flex justify-between" data-id="element-11350" data-mp="2ry2acap6oolb">
          <button className="px-3 py-1.5 text-xs bg-white/10 text-blue-200 rounded hover:bg-white/20 hover:text-white transition-colors" data-id="element-11351" data-mp="2rv7pii29d1rd">
            <FileTextIcon size={14} className="mr-1" data-id="element-11352" data-mp="30xgz95ppcr3p" />
            Invoice
          </button>
          <button className="px-3 py-1.5 text-xs bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded hover:from-blue-700 hover:to-indigo-700 transition-colors" data-id="element-11353" data-mp="2d7mm0n1h10ix">
            <EyeIcon size={14} className="mr-1" data-id="element-11354" data-mp="28778nvh6vt0y" />
            Details
          </button>
        </div>
      </div>
    </div>;
}
// Empty state component
function EmptyState({
  onClearFilters,
  className = ''
}) {
  return <div className={`p-8 text-center ${className}`} data-id="element-11355" data-mp="eqkuzprpil1j">
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-900/20 mb-4" data-id="element-11356" data-mp="es5ord675zyc">
        <SearchIcon size={24} className="text-blue-400" data-id="element-11357" data-mp="jnb947jyb6kb" />
      </div>
      <h3 className="text-lg font-medium text-white mb-2" data-id="element-11358" data-mp="17gbao38zluzr">No orders found</h3>
      <p className="text-blue-300 max-w-md mx-auto" data-id="element-11359" data-mp="1bh3h6oqh5lsc">
        We couldn't find any orders matching your current filters. Try adjusting
        your search criteria or clear all filters.
      </p>
      <button className="mt-4 px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-colors" onClick={onClearFilters} data-id="element-11360" data-mp="12fds3pk2eyxq">
        Clear All Filters
      </button>
    </div>;
}
export function OrdersPage() {
  const [activeTab, setActiveTab] = useState('active');
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [expandedOrder, setExpandedOrder] = useState(null);
  const [viewMode, setViewMode] = useState('list'); // list or grid
  const [sortField, setSortField] = useState('date');
  const [sortDirection, setSortDirection] = useState('desc');
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({
    status: [],
    region: [],
    dateRange: 'all'
  });
  // Mock data for orders
  const orders = [{
    id: 'Q4ZESF',
    status: 'scheduled',
    date: 'Jul 22, 2025',
    billBy: 'Aisco AMERICA',
    billTo: 'VK SALES & SERVICE',
    products: '2 pivots',
    amount: '$ 174,650.94',
    region: 'America',
    shipping: {
      approved: {
        status: 'completed',
        date: 'Jul 24, 2025'
      },
      acknowledgment: {
        status: 'completed',
        date: 'Jul 24, 2025'
      },
      readyToLoad: {
        status: 'completed',
        date: 'Jul 24, 2025'
      },
      shipping: {
        status: 'pending',
        date: 'Jul 30, 2025'
      }
    }
  }, {
    id: 'UMRX5S',
    status: 'shipped',
    date: 'Jul 9, 2025',
    billBy: 'Walsh Auto Supply',
    billTo: 'Walsh Auto Supply',
    products: '2 pivots',
    amount: '$ 302,903.41',
    region: 'America',
    shipping: {
      approved: {
        status: 'completed',
        date: 'Jul 17, 2025'
      },
      acknowledgment: {
        status: 'completed',
        date: 'Jul 17, 2025'
      },
      readyToLoad: {
        status: 'completed',
        date: 'Jul 17, 2025'
      },
      shipping: {
        status: 'completed',
        date: 'Jul 17, 2025'
      }
    }
  }, {
    id: '7IIT03',
    status: 'shipped',
    date: 'Jul 8, 2025',
    billBy: 'Aisco EUROPE',
    billTo: 'IMPER REGAS Lda (Olivenza, Badajoz, España)',
    products: '1 pivot',
    amount: '53,520.49 €',
    region: 'Europe',
    shipping: {
      approved: {
        status: 'completed',
        date: 'Jul 8, 2025'
      },
      acknowledgment: {
        status: 'completed',
        date: 'Jul 8, 2025'
      },
      readyToLoad: {
        status: 'completed',
        date: 'Jul 17, 2025'
      },
      shipping: {
        status: 'completed',
        date: 'Jul 17, 2025'
      }
    }
  }, {
    id: 'H93M5H',
    status: 'shipped',
    date: 'Jun 27, 2025',
    billBy: 'Aisco AMERICA',
    billTo: 'VK SALES & SERVICE',
    products: '4 pivots',
    amount: '$ 249,467.60',
    region: 'America',
    shipping: {
      approved: {
        status: 'completed',
        date: 'Jun 30, 2025'
      },
      acknowledgment: {
        status: 'completed',
        date: 'Jun 30, 2025'
      },
      readyToLoad: {
        status: 'completed',
        date: 'Jul 7, 2025'
      },
      shipping: {
        status: 'completed',
        date: 'Jul 18, 2025'
      }
    }
  }, {
    id: '6URMLZ',
    status: 'pending',
    date: 'Jun 25, 2025',
    billBy: 'CAN AGRO LLP',
    billTo: 'АФ ВЕДЕНОВКА (Очередь 3 v2)',
    products: '7 pivots',
    amount: '$ 477,917.06',
    region: 'Europe',
    shipping: {
      approved: {
        status: 'pending',
        date: ''
      },
      acknowledgment: {
        status: 'pending',
        date: ''
      },
      readyToLoad: {
        status: 'pending',
        date: ''
      },
      shipping: {
        status: 'pending',
        date: ''
      }
    }
  }, {
    id: 'U4OLLY',
    status: 'pending',
    date: 'Jun 18, 2025',
    billBy: 'DAIRY GLOBAL EXPERTS LLC',
    billTo: 'ПСП ВІКТОРІЯ',
    products: '1 pivot',
    amount: '$ 43,228.92',
    region: 'Europe',
    shipping: {
      approved: {
        status: 'pending',
        date: ''
      },
      acknowledgment: {
        status: 'pending',
        date: ''
      },
      readyToLoad: {
        status: 'pending',
        date: ''
      },
      shipping: {
        status: 'pending',
        date: ''
      }
    }
  }];
  // Filter and sort orders
  const filteredOrders = orders.filter(order => {
    // Filter by search query
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      return order.id.toLowerCase().includes(query) || order.billBy.toLowerCase().includes(query) || order.billTo.toLowerCase().includes(query) || order.products.toLowerCase().includes(query);
    }
    // Filter by status
    if (selectedFilters.status.length > 0 && !selectedFilters.status.includes(order.status)) {
      return false;
    }
    // Filter by region
    if (selectedFilters.region.length > 0 && !selectedFilters.region.includes(order.region)) {
      return false;
    }
    // Filter by tab
    if (activeTab === 'active' && order.status === 'canceled') {
      return false;
    } else if (activeTab === 'closed' && order.status !== 'shipped') {
      return false;
    } else if (activeTab === 'canceled' && order.status !== 'canceled') {
      return false;
    }
    return true;
  });
  // Sort orders
  const sortedOrders = [...filteredOrders].sort((a, b) => {
    if (sortField === 'date') {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return sortDirection === 'asc' ? dateA - dateB : dateB - dateA;
    } else if (sortField === 'amount') {
      const amountA = parseFloat(a.amount.replace(/[^0-9.-]+/g, ''));
      const amountB = parseFloat(b.amount.replace(/[^0-9.-]+/g, ''));
      return sortDirection === 'asc' ? amountA - amountB : amountB - amountA;
    } else if (sortField === 'id') {
      return sortDirection === 'asc' ? a.id.localeCompare(b.id) : b.id.localeCompare(a.id);
    }
    return 0;
  });
  const getStatusColor = status => {
    switch (status) {
      case 'shipped':
        return 'text-emerald-500';
      case 'scheduled':
        return 'text-blue-500';
      case 'pending':
        return 'text-amber-500';
      case 'canceled':
        return 'text-red-500';
      default:
        return 'text-gray-500';
    }
  };
  const getStatusBg = status => {
    switch (status) {
      case 'shipped':
        return 'bg-emerald-500/20';
      case 'scheduled':
        return 'bg-blue-500/20';
      case 'pending':
        return 'bg-amber-500/20';
      case 'canceled':
        return 'bg-red-500/20';
      default:
        return 'bg-gray-500/20';
    }
  };
  const getStatusIcon = status => {
    switch (status) {
      case 'shipped':
        return <TruckIcon size={14} data-id="element-11361" data-mp="39iyxbt92zz5l" />;
      case 'scheduled':
        return <CalendarIcon size={14} data-id="element-11362" data-mp="3eha7y677adov" />;
      case 'pending':
        return <ClockIcon size={14} data-id="element-11363" data-mp="3jfbs6ugd4j1x" />;
      case 'canceled':
        return <XCircleIcon size={14} data-id="element-11364" data-mp="3jdqyf71vh454" />;
      default:
        return <InfoIcon size={14} data-id="element-11365" data-mp="3nhf4tmerptos" />;
    }
  };
  const getShippingStatusIcon = status => {
    switch (status) {
      case 'completed':
        return <CheckCircleIcon size={16} className="text-emerald-500" data-id="element-11366" data-mp="yojlo7aiiqs9" />;
      case 'pending':
        return <ClockIcon size={16} className="text-gray-400" data-id="element-11367" data-mp="12p3if9r6bsdv" />;
      default:
        return <AlertCircleIcon size={16} className="text-amber-500" data-id="element-11368" data-mp="2n7nryr1mlrls" />;
    }
  };
  const handleOrderClick = id => {
    setExpandedOrder(expandedOrder === id ? null : id);
  };
  const toggleSort = field => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('desc');
    }
  };
  const toggleFilter = (type, value) => {
    setSelectedFilters(prev => {
      const newFilters = {
        ...prev
      };
      if (type === 'dateRange') {
        newFilters.dateRange = value;
      } else {
        if (newFilters[type].includes(value)) {
          newFilters[type] = newFilters[type].filter(item => item !== value);
        } else {
          newFilters[type] = [...newFilters[type], value];
        }
      }
      return newFilters;
    });
  };
  return <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950" data-id="element-11369" data-mp="3kwhgl020brx9">
      {/* Header with navigation */}
      <header className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 border-b border-blue-800/30 relative z-10" data-id="element-11370" data-mp="2hlbr95oc4eoq">
        <div className="px-6 py-4 flex justify-between items-center" data-id="element-11371" data-mp="2mk4v06dtkrbp">
          <div className="flex items-center" data-id="element-11372" data-mp="28loq8kzipaw7">
            <div className="p-2 mr-3 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-lg" data-id="element-11373" data-mp="28mzpq8lxjwhi">
              <TruckIcon size={20} className="text-white" data-id="element-11374" data-mp="2dm2vjv9qi6qj" />
            </div>
            <div data-id="element-11375" data-mp="1ytixh91fypfy">
              <h1 className="text-xl font-bold text-white" data-id="element-11376" data-mp="1yszctkkepmy8">Orders</h1>
              <p className="text-blue-200 text-sm hidden sm:block" data-id="element-11377" data-mp="23mkg9s4rr94t">
                Manage and track all your orders
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-3" data-id="element-11378" data-mp="1tvhe0n03so3y">
            <div className="relative hidden sm:block" data-id="element-11379" data-mp="1tw927crdfjk7">
              <div className="relative" data-id="element-11380" data-mp="1fvy7fymxxktr">
                <input type="text" placeholder="Search..." className="bg-white/10 border border-blue-800/30 rounded-full pl-10 pr-4 py-2 text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500 w-56" data-id="element-11381" data-mp="1fwzrgslxphnm" />
                <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-blue-300" size={18} data-id="element-11382" data-mp="wafxkd8p7wrf" />
              </div>
            </div>
            <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-11383" data-mp="1b99wpy9bufyy">
              <CalendarIcon size={20} data-id="element-11384" data-mp="16aou5s6lrk7c" />
            </button>
            <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-11385" data-mp="1k7bs9yaakgeu">
              <BarChart3Icon size={20} data-id="element-11386" data-mp="1f8r26ror7d44" />
            </button>
            <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-11387" data-mp="1typwgjd6u4eb">
              <HelpCircleIcon size={20} data-id="element-11388" data-mp="1p04w8jxxrkpv" />
            </button>
            <div className="relative" data-id="element-11389" data-mp="22yuw27c53yhx">
              <button className="p-2 text-blue-300 hover:text-white rounded-full hover:bg-white/10 transition-colors" data-id="element-11390" data-mp="22zwgv3iyjzcu">
                <BellIcon size={20} data-id="element-11391" data-mp="1yyudcai0d152" />
                <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full text-xs flex items-center justify-center text-white" data-id="element-11392" data-mp="260hkxo6a5yj1">
                  3
                </span>
              </button>
            </div>
            <div className="flex items-center bg-white/10 hover:bg-white/15 rounded-full pl-2 pr-3 py-1 cursor-pointer transition-colors" data-id="element-11393" data-mp="2fydpty8mjx8p">
              <div className="bg-gradient-to-br from-blue-600 to-indigo-700 rounded-full w-8 h-8 flex items-center justify-center mr-2" data-id="element-11394" data-mp="2kqosv9ynvz5h">
                <UserIcon size={16} className="text-white" data-id="element-11395" data-mp="2tpsccf1qqgki" />
              </div>
              <span className="text-white text-sm font-medium hidden sm:block" data-id="element-11396" data-mp="2trvcvt0irs3h">
                Daniel Alejandro
              </span>
              <ChevronDownIcon size={16} className="text-blue-300 ml-1 hidden sm:block" data-id="element-11397" data-mp="33ohum8xju31a" />
            </div>
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors shadow-lg flex items-center" data-id="element-11398" data-mp="14bvsffrgag8j">
              <PlusIcon size={16} className="mr-2" data-id="element-11399" data-mp="19cb6k9jk3rrk" />
              New Order
            </button>
          </div>
        </div>
      </header>
      {/* Main content */}
      <div className="p-4 md:p-6" data-id="element-11400" data-mp="3hsp4devuqgdu">
        <div className="bg-white/5 backdrop-blur-md rounded-xl border border-white/10 overflow-hidden shadow-xl" data-id="element-11401" data-mp="3hrnl4n4omnl1">
          {/* Tabs and search */}
          <div className="flex flex-col md:flex-row md:items-center justify-between border-b border-white/10 p-4" data-id="element-11402" data-mp="38tv3vdfeh5v0">
            <div className="flex space-x-1 mb-4 md:mb-0" data-id="element-11403" data-mp="9cndpfws8dpa">
              <TabButton active={activeTab === 'active'} onClick={() => setActiveTab('active')} label="Active orders" data-id="element-11404" data-mp="5cmnyz48gg2x" />
              <TabButton active={activeTab === 'closed'} onClick={() => setActiveTab('closed')} label="Closed orders" data-id="element-11405" data-mp="ch4i6849zvx" />
              <TabButton active={activeTab === 'canceled'} onClick={() => setActiveTab('canceled')} label="Canceled orders" data-id="element-11406" data-mp="3rirzbkmja4et" />
            </div>
            <div className="flex space-x-2" data-id="element-11407" data-mp="2l14vtfamb6q0">
              <div className="relative flex-grow" data-id="element-11408" data-mp="2g3d0sceof4hl">
                <input type="text" placeholder="Search by code, name, dealer, customer..." className="w-full md:w-80 bg-white/5 border border-white/10 rounded-lg pl-10 pr-4 py-2 text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-11409" data-mp="2g6r2difin9nz" />
                <SearchIcon className="absolute left-3 top-2.5 text-blue-300" size={16} data-id="element-11410" data-mp="f1dj59r9rxdf" />
              </div>
              <button className={`p-2 rounded-lg ${filtersOpen ? 'bg-blue-600 text-white' : 'bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white'} transition-colors`} onClick={() => setFiltersOpen(!filtersOpen)} data-id="element-11411" data-mp="12sspreq2x0uh">
                <FilterIcon size={16} data-id="element-11412" data-mp="t1eu5i190l6m" />
              </button>
              <button className="p-2 rounded-lg bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white transition-colors" data-id="element-11413" data-mp="y0j1020pa6ts">
                <DownloadIcon size={16} data-id="element-11414" data-mp="1lpty99iudj36" />
              </button>
              <div className="hidden md:flex space-x-2" data-id="element-11415" data-mp="1qhvhjfefga2p">
                <button className={`p-2 rounded-lg transition-colors ${viewMode === 'list' ? 'bg-blue-600 text-white' : 'bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white'}`} onClick={() => setViewMode('list')} data-id="element-11416" data-mp="1qjexf4w68j3y">
                  <ListIcon size={16} data-id="element-11417" data-mp="3kxkdmxmn06ry" />
                </button>
                <button className={`p-2 rounded-lg transition-colors ${viewMode === 'grid' ? 'bg-blue-600 text-white' : 'bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white'}`} onClick={() => setViewMode('grid')} data-id="element-11418" data-mp="3kwr4xr44b776">
                  <GridIcon size={16} data-id="element-11419" data-mp="2sapvw8h7fli6" />
                </button>
              </div>
            </div>
          </div>
          {/* Filters panel */}
          {filtersOpen && <div className="bg-gradient-to-r from-blue-900/30 to-indigo-900/30 border-b border-white/10 p-4" data-id="element-11420" data-mp="31acr2cjcbv2s">
              <div className="flex flex-wrap gap-4" data-id="element-11421" data-mp="2x6oflirl8fc9">
                <div data-id="element-11422" data-mp="gisyb55s9hfi">
                  <h3 className="text-sm font-medium text-white mb-2" data-id="element-11423" data-mp="giarjelhvktc">
                    Status
                  </h3>
                  <div className="flex flex-wrap gap-2" data-id="element-11424" data-mp="chh6qu3cmm4o">
                    {['pending', 'scheduled', 'shipped', 'canceled'].map(status => <button key={status} className={`px-3 py-1.5 rounded-lg text-xs font-medium capitalize flex items-center space-x-1.5 ${selectedFilters.status.includes(status) ? `${getStatusBg(status)} ${getStatusColor(status)}` : 'bg-white/5 text-blue-200 hover:bg-white/10'}`} onClick={() => toggleFilter('status', status)} data-id="element-11425" data-mp="1coplq39hvkn">
                          <span data-id="element-11426" data-mp="k97ug3718xbe">{getStatusIcon(status)}</span>
                          <span data-id="element-11427" data-mp="k7d4gagwmf0g">{status}</span>
                          {selectedFilters.status.includes(status) && <XCircleIcon size={12} data-id="element-11428" data-mp="g61n0s86p03c" />}
                        </button>)}
                  </div>
                </div>
                <div data-id="element-11429" data-mp="p0psojho8jso">
                  <h3 className="text-sm font-medium text-white mb-2" data-id="element-11430" data-mp="p06b53vxnxf6">
                    Region
                  </h3>
                  <div className="flex flex-wrap gap-2" data-id="element-11431" data-mp="13yi87bn7x86v">
                    {['America', 'Europe', 'Asia', 'ANZ'].map(region => <button key={region} className={`px-3 py-1.5 rounded-lg text-xs font-medium capitalize flex items-center space-x-1.5 ${selectedFilters.region.includes(region) ? 'bg-indigo-500/20 text-indigo-300' : 'bg-white/5 text-blue-200 hover:bg-white/10'}`} onClick={() => toggleFilter('region', region)} data-id="element-11432" data-mp="z06u2opw4biu">
                        <MapPinIcon size={12} data-id="element-11433" data-mp="18oc6gmttb6va" />
                        <span data-id="element-11434" data-mp="1dkjecl5rqsfv">{region}</span>
                        {selectedFilters.region.includes(region) && <XCircleIcon size={12} data-id="element-11435" data-mp="yvwo3oelsg9v" />}
                      </button>)}
                  </div>
                </div>
                <div data-id="element-11436" data-mp="13ny9q0xnvjck">
                  <h3 className="text-sm font-medium text-white mb-2" data-id="element-11437" data-mp="13og40s0rjnhu">
                    Date Range
                  </h3>
                  <div className="flex flex-wrap gap-2" data-id="element-11438" data-mp="uuunp48y9y6b">
                    {[{
                  id: 'all',
                  label: 'All Time'
                }, {
                  id: 'today',
                  label: 'Today'
                }, {
                  id: 'week',
                  label: 'This Week'
                }, {
                  id: 'month',
                  label: 'This Month'
                }, {
                  id: 'quarter',
                  label: 'This Quarter'
                }].map(range => <button key={range.id} className={`px-3 py-1.5 rounded-lg text-xs font-medium capitalize flex items-center space-x-1.5 ${selectedFilters.dateRange === range.id ? 'bg-blue-500/20 text-blue-300' : 'bg-white/5 text-blue-200 hover:bg-white/10'}`} onClick={() => toggleFilter('dateRange', range.id)} data-id="element-11439" data-mp="3o7d7htbeae23">
                        <CalendarIcon size={12} data-id="element-11440" data-mp="frjsxk0mjcno" />
                        <span data-id="element-11441" data-mp="fpqn26xu4wgq">{range.label}</span>
                      </button>)}
                  </div>
                </div>
              </div>
              <div className="flex justify-between mt-4 pt-4 border-t border-white/5" data-id="element-11442" data-mp="5uf4fdjb353p">
                <button className="px-3 py-1.5 rounded-lg text-xs font-medium bg-white/5 text-blue-200 hover:bg-white/10 transition-colors" onClick={() => setSelectedFilters({
              status: [],
              region: [],
              dateRange: 'all'
            })} data-id="element-11443" data-mp="2vjh2m1bo9fu8">
                  Clear All Filters
                </button>
                <div className="text-sm text-blue-300" data-id="element-11444" data-mp="1b1on3qf656ah">
                  Showing{' '}
                  <span className="font-medium text-white" data-id="element-11445" data-mp="1fyykptcpoo9e">
                    {sortedOrders.length}
                  </span>{' '}
                  of{' '}
                  <span className="font-medium text-white" data-id="element-11446" data-mp="1pptah7p625zl">
                    {orders.length}
                  </span>{' '}
                  orders
                </div>
              </div>
            </div>}
          {viewMode === 'list' ? <>
              {/* Table header */}
              <div className="hidden md:grid grid-cols-12 gap-2 p-4 text-xs font-medium text-blue-300 border-b border-white/10" data-id="element-11447" data-mp="1yooh2kw4hi3f">
                <div className="col-span-1" data-id="element-11448" data-mp="4czz09ulgzet">Status</div>
                <div className="col-span-2 flex items-center cursor-pointer group" onClick={() => toggleSort('id')} data-id="element-11449" data-mp="4eb54gbiij93">
                  Code / Date
                  <button className="ml-1 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-11450" data-mp="1zs5blg6hvni0">
                    {sortField === 'id' ? sortDirection === 'asc' ? <ArrowUpIcon size={12} data-id="element-11451" data-mp="1utc0tvilealj" /> : <ArrowDownIcon size={12} data-id="element-11452" data-mp="28tcyz37h33xb" /> : <ArrowUpDownIcon size={12} data-id="element-11453" data-mp="28tmqiv861j54" />}
                  </button>
                </div>
                <div className="col-span-3" data-id="element-11454" data-mp="24ri005d0l2mp">Bill by / Bill to</div>
                <div className="col-span-2" data-id="element-11455" data-mp="24px1y5rhr1k3">Products</div>
                <div className="col-span-3" data-id="element-11456" data-mp="1h2ysvt5pavw7">Shipping schedule</div>
                <div className="col-span-1 text-right" data-id="element-11457" data-mp="1c3m4v533fis1">Actions</div>
              </div>
              {/* Table content */}
              <div className="divide-y divide-white/10" data-id="element-11458" data-mp="1pvir4si2yygi">
                {sortedOrders.length > 0 ? sortedOrders.map(order => <div key={order.id} className="group" data-id="element-11459" data-mp="1l27l2tl3elpn">
                      <div className="grid grid-cols-1 md:grid-cols-12 gap-2 p-4 hover:bg-white/5 cursor-pointer transition-colors" onClick={() => handleOrderClick(order.id)} data-id="element-11460" data-mp="xdobmaqb42vz">
                        {/* Status - Mobile & Desktop */}
                        <div className="col-span-1 flex md:block items-center justify-between" data-id="element-11461" data-mp="j7w7pg9lq8m3">
                          <div className={`flex items-center space-x-1.5 ${getStatusColor(order.status)}`} data-id="element-11462" data-mp="o061x8hr1uu6">
                            <span className={`p-1 rounded-md ${getStatusBg(order.status)}`} data-id="element-11463" data-mp="9c1ig2avhfac">
                              {getStatusIcon(order.status)}
                            </span>
                            <span className="capitalize font-medium" data-id="element-11464" data-mp="120gssbj279fc">
                              {order.status}
                            </span>
                          </div>
                          <button className="md:hidden p-1.5 rounded-lg text-blue-300 hover:bg-white/10 hover:text-white" data-id="element-11465" data-mp="s1r9qffffixi">
                            <ChevronRightIcon size={16} className={`transition-transform ${expandedOrder === order.id ? 'rotate-90' : ''}`} data-id="element-11466" data-mp="wyhp10jeqahv" />
                          </button>
                        </div>
                        {/* Code & Date - Desktop */}
                        <div className="col-span-2 hidden md:block" data-id="element-11467" data-mp="1o82riiw5dspx">
                          <div className="font-medium text-white" data-id="element-11468" data-mp="1o9dvaiplf0h1">
                            {order.id}
                          </div>
                          <div className="text-sm text-blue-300 flex items-center mt-1" data-id="element-11469" data-mp="1egzqti74rfr6">
                            <CalendarIcon size={14} className="mr-1.5" data-id="element-11470" data-mp="19j6l0q9qonrf" />
                            {order.date}
                          </div>
                        </div>
                        {/* Code & Date - Mobile */}
                        <div className="md:hidden flex justify-between items-center" data-id="element-11471" data-mp="10h72tumzndmw">
                          <div data-id="element-11472" data-mp="vi404guhdji3">
                            <div className="font-medium text-white" data-id="element-11473" data-mp="vj5m3gd1bqel">
                              {order.id}
                            </div>
                            <div className="text-sm text-blue-300 flex items-center mt-1" data-id="element-11474" data-mp="2pwogihbrqsvo">
                              <CalendarIcon size={14} className="mr-1.5" data-id="element-11475" data-mp="2ky3bm4lknl0w" />
                              {order.date}
                            </div>
                          </div>
                        </div>
                        {/* Bill by / Bill to - Desktop */}
                        <div className="col-span-3 hidden md:block" data-id="element-11476" data-mp="2xecsmd6ksuj6">
                          <div className="font-medium text-white flex items-center" data-id="element-11477" data-mp="328gysu80oyj7">
                            <BuildingIcon size={14} className="mr-1.5 text-blue-400" data-id="element-11478" data-mp="3757evhjtnu4m" />
                            {order.billBy}
                          </div>
                          <div className="text-sm text-blue-300 mt-1 flex items-center" data-id="element-11479" data-mp="2ehld8eu5mzke">
                            <UserIcon size={14} className="mr-1.5 text-blue-400" data-id="element-11480" data-mp="2ejejvu4rpjse" />
                            <span className="truncate" data-id="element-11481" data-mp="2jfd6pdag6tqp">{order.billTo}</span>
                          </div>
                        </div>
                        {/* Products - Desktop */}
                        <div className="col-span-2 hidden md:flex flex-col" data-id="element-11482" data-mp="3uvbg5i9jfhsg">
                          <div className="font-medium text-white flex items-center" data-id="element-11483" data-mp="3oh64uwuv2z8">
                            <BoxIcon size={14} className="mr-1.5 text-blue-400" data-id="element-11484" data-mp="ost2b057ulfy" />
                            {order.products}
                          </div>
                          <div className="text-sm text-blue-300 mt-1 flex items-center" data-id="element-11485" data-mp="jsn4t3c9m4py">
                            <TagIcon size={14} className="mr-1.5 text-blue-400" data-id="element-11486" data-mp="ylgwdn4tabaz" />
                            {order.amount}
                          </div>
                        </div>
                        {/* Shipping schedule - Desktop */}
                        <div className="col-span-3 hidden md:block" data-id="element-11487" data-mp="13j0dcusw926m">
                          <div className="grid grid-cols-4 gap-1" data-id="element-11488" data-mp="13ktlkej5nugq">
                            <ShippingStatusBox status={order.shipping.approved.status} label="Approved" date={order.shipping.approved.date} data-id="element-11489" data-mp="1hhqagafpr1uz" />
                            <ShippingStatusBox status={order.shipping.acknowledgment.status} label="Ack." date={order.shipping.acknowledgment.date} data-id="element-11490" data-mp="3j9d2mfbcd2t1" />
                            <ShippingStatusBox status={order.shipping.readyToLoad.status} label="Ready" date={order.shipping.readyToLoad.date} data-id="element-11491" data-mp="3ec33g7y5hcs0" />
                            <ShippingStatusBox status={order.shipping.shipping.status} label="Ship" date={order.shipping.shipping.date} data-id="element-11492" data-mp="1yrkly133qn7p" />
                          </div>
                        </div>
                        {/* Actions - Desktop */}
                        <div className="col-span-1 flex justify-end items-start space-x-1 hidden md:flex" data-id="element-11493" data-mp="1p0g8j5t2raez">
                          <button className="p-1.5 rounded-lg text-blue-300 hover:bg-white/10 hover:text-white" data-id="element-11494" data-mp="1b0ezv46kiyoy">
                            <EyeIcon size={16} data-id="element-11495" data-mp="1fyzyiz669aba" />
                          </button>
                          <button className="p-1.5 rounded-lg text-blue-300 hover:bg-white/10 hover:text-white" data-id="element-11496" data-mp="115daq8calwmd">
                            <FileTextIcon size={16} data-id="element-11497" data-mp="164zm0c8k92sj" />
                          </button>
                          <button className="p-1.5 rounded-lg text-blue-300 hover:bg-white/10 hover:text-white" data-id="element-11498" data-mp="2vicy4nmwzv47">
                            <MoreHorizontalIcon size={16} data-id="element-11499" data-mp="30etsw0omd7q9" />
                          </button>
                        </div>
                      </div>
                      {/* Expanded view */}
                      {expandedOrder === order.id && <div className="bg-gradient-to-r from-blue-900/30 to-indigo-900/30 p-4 border-t border-white/10" data-id="element-11500" data-mp="el43c3y7cydj">
                          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-11501" data-mp="jbu6daj5op52">
                            <div className="bg-white/5 rounded-lg p-4" data-id="element-11502" data-mp="oaxbeuz4yvd1">
                              <h3 className="text-sm font-medium text-white mb-3 flex items-center" data-id="element-11503" data-mp="od01ff0agohr">
                                <InfoIcon size={14} className="mr-1.5 text-blue-400" data-id="element-11504" data-mp="tbl5jpinvsbh" />
                                Order Details
                              </h3>
                              <div className="space-y-3" data-id="element-11505" data-mp="129wr3d4o7zx2">
                                <div className="flex justify-between" data-id="element-11506" data-mp="2z38bdctke0fj">
                                  <span className="text-sm text-blue-300" data-id="element-11507" data-mp="2z52z0yw806nb">
                                    Order ID:
                                  </span>
                                  <span className="text-sm text-white font-medium" data-id="element-11508" data-mp="2wj25v0pay1wv">
                                    {order.id}
                                  </span>
                                </div>
                                <div className="flex justify-between" data-id="element-11509" data-mp="2mt0mgm7w97oa">
                                  <span className="text-sm text-blue-300" data-id="element-11510" data-mp="2hufj4dxci7vm">
                                    Order Date:
                                  </span>
                                  <span className="text-sm text-white" data-id="element-11511" data-mp="3ai1vaakn2ku3">
                                    {order.date}
                                  </span>
                                </div>
                                <div className="flex justify-between" data-id="element-11512" data-mp="31hdi1i32koi9">
                                  <span className="text-sm text-blue-300" data-id="element-11513" data-mp="31jg63wknw7kc">
                                    Status:
                                  </span>
                                  <span className={`text-sm font-medium capitalize ${getStatusColor(order.status)}`} data-id="element-11514" data-mp="1q15cd7sccx2d">
                                    {order.status}
                                  </span>
                                </div>
                                <div className="flex justify-between" data-id="element-11515" data-mp="1wgdulncv2v0i">
                                  <span className="text-sm text-blue-300" data-id="element-11516" data-mp="1hko71ks129to">
                                    Amount:
                                  </span>
                                  <span className="text-sm text-white font-medium" data-id="element-11517" data-mp="18scjq7s7n2hx">
                                    {order.amount}
                                  </span>
                                </div>
                                <div className="flex justify-between" data-id="element-11518" data-mp="yvhn5ufhzc6a">
                                  <span className="text-sm text-blue-300" data-id="element-11519" data-mp="13tjfz72q6puy">
                                    Region:
                                  </span>
                                  <span className="text-sm text-white" data-id="element-11520" data-mp="putihqbzuo62">
                                    {order.region}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="bg-white/5 rounded-lg p-4" data-id="element-11521" data-mp="699ss1hg3k5j">
                              <h3 className="text-sm font-medium text-white mb-3 flex items-center" data-id="element-11522" data-mp="k7rdrrfyuijr">
                                <BuildingIcon size={14} className="mr-1.5 text-blue-400" data-id="element-11523" data-mp="f96djs0pryvb" />
                                Billing Information
                              </h3>
                              <div className="space-y-3" data-id="element-11524" data-mp="u3ud6pjfo330">
                                <div className="flex justify-between" data-id="element-11525" data-mp="p6b03syh1wcn">
                                  <span className="text-sm text-blue-300" data-id="element-11526" data-mp="12z0ou55dxfdg">
                                    Bill by:
                                  </span>
                                  <span className="text-sm text-white" data-id="element-11527" data-mp="yz9nj7i8fguo">
                                    {order.billBy}
                                  </span>
                                </div>
                                <div className="flex justify-between" data-id="element-11528" data-mp="17vqzue2c1ks0">
                                  <span className="text-sm text-blue-300" data-id="element-11529" data-mp="1rz6oqr4hozjc">
                                    Bill to:
                                  </span>
                                  <span className="text-sm text-white" data-id="element-11530" data-mp="20ri6zppg9go8">
                                    {order.billTo}
                                  </span>
                                </div>
                                <div className="flex justify-between" data-id="element-11531" data-mp="191m11ndgo70b">
                                  <span className="text-sm text-blue-300" data-id="element-11532" data-mp="1d2fpchutfntq">
                                    Products:
                                  </span>
                                  <span className="text-sm text-white" data-id="element-11533" data-mp="1hzxqhm2lcyr6">
                                    {order.products}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="bg-white/5 rounded-lg p-4" data-id="element-11534" data-mp="2yez6jfxb8130">
                              <h3 className="text-sm font-medium text-white mb-3 flex items-center" data-id="element-11535" data-mp="ms5jc78nw5oa">
                                <TruckIcon size={14} className="mr-1.5 text-blue-400" data-id="element-11536" data-mp="htlw83ic0nuc" />
                                Shipping Timeline
                              </h3>
                              <div className="space-y-3" data-id="element-11537" data-mp="d0j1vt5qdad3">
                                <div className="flex items-center" data-id="element-11538" data-mp="82hdcspjciu8">
                                  {getShippingStatusIcon(order.shipping.approved.status)}
                                  <div className="ml-2" data-id="element-11539" data-mp="3v88hnmdvwhzy">
                                    <div className="text-sm text-white" data-id="element-11540" data-mp="3v6nmbujqwv11">
                                      Approved
                                    </div>
                                    <div className="text-xs text-blue-300" data-id="element-11541" data-mp="3lauakddup5kb">
                                      {order.shipping.approved.date || 'Pending'}
                                    </div>
                                  </div>
                                </div>
                                <div className="flex items-center" data-id="element-11542" data-mp="3dywfnu2657d3">
                                  {getShippingStatusIcon(order.shipping.acknowledgment.status)}
                                  <div className="ml-2" data-id="element-11543" data-mp="3iqxm2zcno3v7">
                                    <div className="text-sm text-white" data-id="element-11544" data-mp="341hyttcc2gk9">
                                      Acknowledgment
                                    </div>
                                    <div className="text-xs text-blue-300" data-id="element-11545" data-mp="k03umhnt419">
                                      {order.shipping.acknowledgment.date || 'Pending'}
                                    </div>
                                  </div>
                                </div>
                                <div className="flex items-center" data-id="element-11546" data-mp="3nqsbszkp2neo">
                                  {getShippingStatusIcon(order.shipping.readyToLoad.status)}
                                  <div className="ml-2" data-id="element-11547" data-mp="2c8hha8kjv8vn">
                                    <div className="text-sm text-white" data-id="element-11548" data-mp="2gb5uesgar1yf">
                                      Ready to load
                                    </div>
                                    <div className="text-xs text-blue-300" data-id="element-11549" data-mp="28ps7dpk3apvw">
                                      {order.shipping.readyToLoad.date || 'Pending'}
                                    </div>
                                  </div>
                                </div>
                                <div className="flex items-center" data-id="element-11550" data-mp="2ds10qn0vjtyj">
                                  {getShippingStatusIcon(order.shipping.shipping.status)}
                                  <div className="ml-2" data-id="element-11551" data-mp="1l2aneg72gw3h">
                                    <div className="text-sm text-white" data-id="element-11552" data-mp="1l3vh63lk4b0a">
                                      Shipping
                                    </div>
                                    <div className="text-xs text-blue-300" data-id="element-11553" data-mp="1uzyf0x9dlnhf">
                                      {order.shipping.shipping.date || 'Pending'}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flex justify-end mt-4 space-x-2" data-id="element-11554" data-mp="lr2nb2ow7asc">
                            <button className="px-3 py-1.5 text-sm bg-white/10 text-white rounded-lg hover:bg-white/20 transition-colors" data-id="element-11555" data-mp="lt5o8hrl2obu">
                              Download Invoice
                            </button>
                            <button className="px-3 py-1.5 text-sm bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-colors" data-id="element-11556" data-mp="zrdek6u46re1">
                              View Details
                            </button>
                          </div>
                        </div>}
                    </div>) : <EmptyState onClearFilters={() => setSelectedFilters({
              status: [],
              region: [],
              dateRange: 'all'
            })} data-id="element-11557" data-mp="1eeosughokphu" />}
              </div>
            </> :
        // Grid view
        <div className="p-4" data-id="element-11558" data-mp="1nellsub3saip">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-11559" data-mp="37ygv80bvqxcg">
                {sortedOrders.length > 0 ? sortedOrders.map(order => <OrderCard key={order.id} order={order} data-id="element-11560" data-mp="32yuhzqw1xh3n" />) : <EmptyState onClearFilters={() => setSelectedFilters({
              status: [],
              region: [],
              dateRange: 'all'
            })} className="col-span-full" data-id="element-11561" data-mp="2yy0yratk0qh3" />}
              </div>
            </div>}
          {/* Pagination */}
          {sortedOrders.length > 0 && <div className="flex items-center justify-between p-4 border-t border-white/10" data-id="element-11562" data-mp="3qr1b8h6hd7yu">
              <div className="text-sm text-blue-300" data-id="element-11563" data-mp="3mpza1ut06lu8">
                Showing{' '}
                <span className="font-medium text-white" data-id="element-11564" data-mp="3hv26h3eht4oq">
                  {sortedOrders.length}
                </span>{' '}
                of{' '}
                <span className="font-medium text-white" data-id="element-11565" data-mp="e8blh28i1cqi">{orders.length}</span>{' '}
                orders
              </div>
              <div className="flex items-center space-x-1" data-id="element-11566" data-mp="9gbeipu0hjkf">
                <button className="p-2 rounded-lg bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white transition-colors" data-id="element-11567" data-mp="25dvjof0xanri">
                  <ChevronLeftIcon size={16} data-id="element-11568" data-mp="21dl6ahaswv2m" />
                </button>
                <button className="w-8 h-8 rounded-lg bg-gradient-to-r from-blue-600 to-indigo-600 text-white flex items-center justify-center" data-id="element-11569" data-mp="1wla3n6ooev6d">
                  1
                </button>
                <button className="w-8 h-8 rounded-lg bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white transition-colors flex items-center justify-center" data-id="element-11570" data-mp="1mnduulj7ocbf">
                  2
                </button>
                <button className="w-8 h-8 rounded-lg bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white transition-colors flex items-center justify-center" data-id="element-11571" data-mp="1dmfpnzx1dyr9">
                  3
                </button>
                <button className="w-8 h-8 rounded-lg bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white transition-colors flex items-center justify-center" data-id="element-11572" data-mp="3818jpui9uhh3">
                  4
                </button>
                <button className="p-2 rounded-lg bg-white/5 text-blue-300 hover:bg-white/10 hover:text-white transition-colors" data-id="element-11573" data-mp="3aklnjk2fmgoh">
                  <ChevronRightIcon size={16} data-id="element-11574" data-mp="3fiesyavwv6np" />
                </button>
              </div>
            </div>}
        </div>
      </div>
    </div>;
}